export const nicknameEvents = {
  nicknamePopupShown: "nickname popup shown",
  nicknameSaveButtonClicked: "nickname save button clicked",
  nicknameRemindMeLaterButtonClicked: "nickname remind me later button clicked"
};
